module.exports = __webpack_public_path__ + "static/media/blob1.b901f526.png";